import React from 'react';
import _ from 'lodash';
import { useMutation, useQuery } from 'react-fetching-library';
import {
  Modal,
  Card,
  CardContent,
  CardHeader,
  IconButton,
  Stack,
  Alert,
  Button,
  Portal,
  Typography
} from '@mui/material';
import { SmallFormDateField } from '../../../components/small-fields/SmallFormDateField';
import { SmallFormTextField } from '../../../components/small-fields/SmallFormTextField';

import {
  editInvoiceTemplateAction,
  getInvoiceTemplateAction
} from '../../../services/request';
import { formatDate } from '../../../services/functions';

import CloseIcon from '@mui/icons-material/Close';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
};

export default function EditInvoiceTemplateModal({
  handleClose,
  setTemplates,
  invoiceTemplate
}) {
  const refInputFile = React.useRef(null);
  const [fileName, setFileName] = React.useState('');
  const [invoiceType, setInvoiceType] = React.useState(
    invoiceTemplate.invoice_type
  );
  const [date, setDate] = React.useState(formatDate(invoiceTemplate.since));
  const [carboneTemplateID, setCarboneTemplateID] = React.useState(
    invoiceTemplate.carbone_template_id
  );
  const [errorMessage, setErrorMessage] = React.useState('');
  const [choices, setChoices] = React.useState([]);
  const { mutate, loading: isSubmitting } = useMutation(
    editInvoiceTemplateAction
  );
  const optionsRequest = useQuery(getInvoiceTemplateAction('OPTIONS'));

  const handleFileSelect = e => {
    if (refInputFile.current.files[0]) {
      setFileName(refInputFile.current.files[0].name);
    } else {
      setFileName(e.target.files[0].name);
    }
  };

  const handleChangeDate = value => {
    setDate(formatDate(value));
  };

  const handleChangeInvoiceType = e => setInvoiceType(e.target.value);
  const handleChangeCarboneTemplateID = e => setCarboneTemplateID(e.target.value);

  const handleSubmit = async () => {
    if (invoiceType !== '') {
      const formData = new FormData();

      if (!_.isNil(refInputFile.current.files[0])) {
        formData.append('file', refInputFile.current.files[0]);
      }

      formData.append('invoice_type', invoiceType);
      formData.append('since', date);
      formData.append('carbone_template_id', carboneTemplateID);

      const { error, payload } = await mutate(invoiceTemplate.id, formData);

      if (!error) {
        if (payload.message !== undefined) {
          setErrorMessage(payload.message);
        } else {
          setTemplates(prev => prev.map(t => (t.id === invoiceTemplate.id ? payload : t))
          );
          handleClose();
        }
      } else {
        setErrorMessage(payload?.message || 'Wystąpił błąd');
      }
    }
  };

  React.useEffect(() => {
    if (!optionsRequest.loading && !optionsRequest.error) {
      setChoices(optionsRequest.payload.actions.GET.choices);
    }
  }, [optionsRequest.loading]);

  return (
    <Portal>
      <Modal open={true} onClose={handleClose}>
        <Card sx={{ ...style, width: '500px' }}>
          <CardHeader
            title={`Edytuj szablon ${invoiceTemplate.file_name}`}
            action={
              <IconButton color="primary" onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            }
          />
          <CardContent>
            <Stack
              spacing={3}
              justifyContent="flex-start"
              alignItems="flex-start"
            >
              <SmallFormTextField
                select
                name="invoice_type"
                placeholder="Rodzaj dokumentu"
                label="Rodzaj dokumentu"
                onChange={handleChangeInvoiceType}
                value={invoiceType}
                sx={{ width: '100%' }}
                options={choices.invoice_type}
              />
              <Stack direction="row" spacing={2} alignItems="center">
                <Button
                  variant="contained"
                  component="label"
                  sx={{ textAlign: 'center' }}
                >
                  Wczytaj plik
                  <input
                    type="file"
                    accept=".odt"
                    hidden
                    ref={refInputFile}
                    onChange={handleFileSelect}
                  />
                </Button>
                {fileName !== '' ? (
                  <Stack direction="row" spacing={1}>
                    <InsertDriveFileOutlinedIcon color="primary" />
                    <Typography variant="subtitle2">{fileName}</Typography>
                  </Stack>
                ) : null}
              </Stack>
              <SmallFormDateField
                value={date}
                onChange={handleChangeDate}
                label="Szablon obowiązuje od"
                sx={{ width: '100%' }}
              />
              <SmallFormTextField
                value={carboneTemplateID}
                onChange={handleChangeCarboneTemplateID}
                label="Carbone id"
                sx={{ width: '100%' }}
                disabled={true}
              />

              {errorMessage !== '' ? (
                <Alert
                  variant="outlined"
                  severity="error"
                  sx={{ width: '100%' }}
                >
                  {errorMessage}
                </Alert>
              ) : null}
              <Button
                variant="contained"
                fullWidth
                disabled={isSubmitting}
                onClick={handleSubmit}
              >
                edytuj
              </Button>
            </Stack>
          </CardContent>
        </Card>
      </Modal>
    </Portal>
  );
}
